import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { postSignAgreements, SignAgreementsDto } from 'src/api/basketService';
import { Basket } from 'src/store/slices/basket-slice';

export const usePostSignAgreements = () =>
    useMutation<
        Basket,
        AxiosError,
        { basketId: string; agreementsData: SignAgreementsDto; updatedAt: string }
    >({
        mutationFn: ({ basketId, agreementsData, updatedAt }) =>
            postSignAgreements(basketId, agreementsData, updatedAt),
    });
